<template lang="pug">
  v-card.v-card--wizard(elevation="12" :max-width="isMobile ? '100%' : 870" :min-height="isMobile ? '100vh' : ''")
    v-card-title.white--text.justify-center.text-h3.font-weight-light.pt-5(style="background: #008e95;")
      | {{ title }}
    dots(:length="items.length" :activeDot="internalValue+1" :absolute="true")
    .text-center.text-h4.white--text.font-weight-light.mb-6(style="background: #008e95;") {{ subtitle }}
    v-tabs(ref="tabs" v-model="internalValue" background-color="blue lighten-5" color="white" grow slider-size="50")
      v-tabs-slider.mt-1(color="primary")
      v-tab(v-for="(item, i) in items" :key="i" :ripple="false" disabled style="color: black; font-weight: bold;")
        | {{ item }}
    .my-6
    v-card-text
      v-tabs-items(v-model="internalValue")
        slot

    //- v-card-actions.pb-4.pa-4
    .text-center.pb-4.pa-4
      v-btn.white--text(:disabled="internalValue === 0" min-width="125" @click="clickPrev")
        | Atras
      v-btn(color="#008e95" min-width="100" :disabled="title === 'Personaliza tu perfil' && !availableSteps.includes(internalValue + 1)" :loading="loading" @click="clickNext")
        | {{ internalValue === items.length - 1 ? 'Finalizar' : 'Siguiente' }}
      //- v-btn(
        :disabled="!availableSteps.includes(internalValue + 1)"
        color="success"
        min-width="100"
        @click="$emit('click:next')"
        ) {{ internalValue === items.length - 1 ? 'Finish' : 'Next' }}
</template>

<script>
  // Mixins
  import Proxyable from 'vuetify/lib/mixins/proxyable'

  export default {
    name: 'BaseMaterialWizard',

    components: {
      dots: () => import('@/components/custom/Dots'),
    },

    mixins: [Proxyable],

    props: {
      title: {
        type: String,
        default: () => 'Personaliza tu perfil',
      },
      subtitle: {
        type: String,
        default: () => 'Registra la información para continuar',
      },
      availableSteps: {
        type: Array,
        default: () => ([]),
      },
      items: {
        type: Array,
        default: () => ([]),
      },
      loading: {
        type: Boolean,
        default: () => false,
      },
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    methods: {
      clickNext () {
        this.$emit('click:next')
        // console.log('estoy aqui')
        /* if (this.isMobile) {
          // console.log(document.getElementsByClassName('v-tabs-bar__content'), 'estoy aqui pero 2')
          document.getElementsByClassName('v-tabs-bar__content')[1].scrollLeft += 140
        } */
      },
      clickPrev () {
        this.$emit('click:prev')
        /* if (this.isMobile) {
          document.getElementsByClassName('v-tabs-bar__content')[1].scrollLeft -= 140
        } */
      },
    },
  }
</script>

<style lang="sass" scoped>
  .v-tabs
    max-width: 100vw
    overflow-x: auto
  .v-card--wizard
    .v-tabs-bar
      height: 56px
      padding: 0 8px

    .v-tabs-slider-wrapper
      overflow: visible

    .v-tabs-slider
      border-radius: 4px

    .v-tabs-slider-wrapper
      contain: initial
      z-index: 0

    .v-tab
      z-index: 1
</style>
